export default __webpack_public_path__ + "static/media/categoryValueIcon.6d7c8f47.png";